import React from 'react';
import { IconBrandWhatsapp } from '@tabler/icons';
import classes from '../styles/WhatsAppButton.module.css';

const WhatsAppButton = () => {
    // International format without + or dashes: 972557259188
    const phoneNumber = '972557259188';
    const message = 'שלום, אשמח לשמוע פרטים נוספים על קוויק-תור'; // Optional predefined message

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <div className={classes.container}>
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.button}
                aria-label="Chat on WhatsApp"
                data-wa-label="floating_button"
            >
                <IconBrandWhatsapp size={32} stroke={1.5} />
            </a>
            {/* Optional tooltip if desired, can be commented out or removed */}
            {/* <span className={classes.tooltip}>דברו איתנו בוואטסאפ</span> */}
        </div>
    );
};

export default WhatsAppButton;
